const formatScore = score => Math.trunc(score * 100)

module.exports = formatScore
